import axios from 'axios';
import axiosInstance  from './AxiosInstance';
import { store } from '../store/store';

const edmApiBaseUrl = process.env.REACT_APP_API_URL;
const edmLocalHostApiBaseUrl = process.env.REACT_APP_LOCALHOST_API_URL;
const ataccamaBaseUrl = process.env.REACT_APP_ATACCAMA_BASEURL;
const ataccamaUsername = process.env.REACT_APP_ATACCAMA_USERNAME;
const ataccamaPassword = process.env.REACT_APP_ATACCAMA_PASSWORD;
const prefectJobsRoute = process.env.REACT_APP_PREFECT_JOBS_ROUTE;
const prefectFlowRunsRoute = process.env.REACT_APP_PREFECT_FLOW_RUNS_ROUTE;
const prefectFlowRunCountsRoute = process.env.REACT_APP_PREFECT_FLOW_RUN_COUNTS_ROUTE;
const failedPrefectJobsRoute = process.env.REACT_APP_FAILED_PREFECT_JOBS_ROUTE;
const successfulPrefectJobsRoute = process.env.REACT_APP_SUCCESSFUL_PREFECT_JOBS_ROUTE;
const prefectDeploymentsRoute = process.env.REACT_APP_PREFECT_DEPLOYMENTS_ROUTE;

export function getPrefectJobs() {
    return axiosInstance.get(prefectFlowRunsRoute)
        .then(response => {
            console.log("response.data.data: ", response.data.data);
            return response.data.data;
        })
        .catch(error => {
            console.error("Error fetching Prefect jobs:", error);
            throw error;
        });
}   

export function getPrefectFlowRunCounts() {
    return axiosInstance.get(prefectFlowRunCountsRoute)
        .then(response => {
            return response.data.data;
        })
        .catch(error => {   
            console.error("Error fetching Prefect flow run counts:", error);
            throw error;
        });
}


export function getPrefectDeployments(env) {
    return axiosInstance.get(`${prefectDeploymentsRoute}?env=${env}`)
        .then(response => {
            return response.data.data;
        })
        .catch(error => {
            console.error("Error fetching Prefect deployments:", error);
            throw error;
        });
}